import { Box, Card, Grid, MenuItem, Select, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import FormControl from "@mui/material/FormControl";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import customerActions from "../../redux/customer/actions";
import DatewiseTable from "../../common/DatewiseTable";

export default function Index() {
    const dispatch = useDispatch();
    const [courseid, setCourseId] = useState(0);
    const [buttonClick, setButtonClick] = useState(false);
    const [courseError, setCourseError] = useState("");

    const { courseList } = useSelector((state) => state.masterReducer);
    const { dateWiseRegistration } = useSelector((state) => state.customerReducer);
console.log(courseid,"pks")
useEffect(()=>{
    setCourseId(0)
    localStorage.removeItem("datewisereport");
},[])
    useEffect(() => {
        
        dispatch({ type: masterActions.GET_COURSE_LIST });
        const storedData = JSON.parse(localStorage.getItem("datewisereport"));
        if (storedData) {
            setCourseId(storedData.courseid);
        }
        dispatch({
                type: customerActions.GET_DATEWISE_REPORT,
                payload: {
                    courseid: 0
                },
            });
        
        return () => {
          
        };
    }, [dispatch]);

    const onChangeCourse = (e) => {
        setCourseId(e.target.value);
    };

    const handleGenerate = () => {
        setButtonClick(true);
        let hasError = false;

        if (courseid === 0) {
            setCourseError("Course is required");
            hasError = true;
        } else {
            setCourseError("");
        }

        if (!hasError) {
            const formData = {
                courseid: courseid
            };
            localStorage.setItem("datewisereport", JSON.stringify(formData));

            dispatch({
                type: customerActions.GET_DATEWISE_REPORT,
                payload: {
                    courseid: courseid
                },
            });
        }
    };

    useEffect(() => {
        const removeLocalStorage = () => {
            localStorage.removeItem("datewisereport");
        };

        window.addEventListener('beforeunload', removeLocalStorage);

        return () => {
            window.removeEventListener('beforeunload', removeLocalStorage);
        };
    }, []);

    const applicationStatusColumns = [
        {
            name: "",
            colSpan: 2,
            subHeaders: [
                { name: "Sr.No", dataIndex: "srNo" },
                { name: "Date (DD-MM-YYYY)", dataIndex: "reportDate" },
            ],
        },
        {
            name: "Registration",
            colSpan: 2,
            subHeaders: [
                { name: "Daily", dataIndex: "registrationDaily" },
                { name: "Cumulative", dataIndex: "registrationCumulative" },
            ],
        },
        {
            name: "",
            dataIndex: "",
            isPlaceholder: true,
        },
        {
            name: "Paid Confirmation",
            colSpan: 3,
            subHeaders: [
                { name: "Daily", dataIndex: "confirmationConfirm" },
                { name: "Cumulative", dataIndex: "confirmationCumulative" },
            ],
        },
    ];

    const applicationStatusData = Array.isArray(dateWiseRegistration)
        ? dateWiseRegistration
            .map((entry, index) => {
                const registered =
                    entry.Registered && Array.isArray(entry.Registered)
                        ? entry.Registered[0]
                        : {};
                const confirmed =
                    entry.Confirmed && Array.isArray(entry.Confirmed)
                        ? entry.Confirmed[0]
                        : {};
                return {
                    srNo: index + 1,
                    reportDate: entry.date || "N/A",
                    registrationDaily: registered.registeredcount || 0,
                    registrationCumulative: registered.cumulativecount || 0,
                    confirmationConfirm: confirmed.confirmedcount || 0,
                    confirmationCumulative: confirmed.cumulativecount || 0,
                    total: confirmed.cumulativecount || 0,
                };
            })
        : [];

    return (
        <>
            <Box
                sx={{
                    margin: "1rem auto",
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    borderRadius: "8px",
                    padding: "10px",
                }}
            >
                <Card sx={{ p: 2 }}>
                    <Typography>Date wise Registration Report</Typography>

                    <Grid item sm={12}>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            sx={{ gap: 2, flexWrap: "wrap", mt: 2 }}
                        >
                            <FormControl error={!!courseError} sx={{ width: "220px" }}>
                                <Select
                                    size="small"
                                    onChange={onChangeCourse}
                                    value={courseid}
                                    defaultValue={0}
                                    sx={{ height: "56px" }}
                                >
                                    <MenuItem value={0} selected>
                                        Select Course <span style={{ color: "red" }}>*</span>
                                    </MenuItem>
                                    {courseList?.all
                                        ?.filter((course) => course.isactive === "1")
                                        .map((course, i) => (
                                            <MenuItem key={i} value={course.courseid}>
                                                {course.coursename}
                                            </MenuItem>
                                        ))}
                                </Select>
                                {courseError && (
                                    <Typography variant="caption" color="error">
                                        {courseError}
                                    </Typography>
                                )}
                            </FormControl>

                            <Box sx={{ marginTop: 1 }}>
                                <BluePrimaryButton
                                    title={"Generate"}
                                    handleSubmit={handleGenerate}
                                />
                            </Box>
                        </Box>
                    </Grid>

                    <Box sx={{ marginTop: 1 }}>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontWeight: "500",
                                color: "black",
                                fontSize: "20px",
                                lineHeight: "24px",
                                mb: 2,
                                backgroundColor: "whitesmoke",
                                padding: "8px",
                                borderRadius: "4px",
                            }}
                        >
                            Date wise Registration Status{" "}
                        </Typography>
                    </Box>
                    <DatewiseTable
                        columnData={applicationStatusColumns}
                        tableData={applicationStatusData}
                    />
                </Card>
            </Box>
        </>
    );
}
